/* lua.js generated code 0.3.0 */

require("clover/config/ResourceConfig")
require("clover/data/MaintenanceManager")
require("clover/data/ReplayManager")
// require("clover/net/SyncManager")
require("clover/scene/BaseScene")
require("clover/net/OnlineSetterHttp")
require("clover/net/OnlineGetterHttp")
require("clover/net/OfflineHttp")
require("clover/logic/CloverLogic")
require("clover/baseUI/commands/funscare/FunscareConfig")
require("clover/baseUI/commands/funscare/OpenFunscareLogic")
require("clover/scene/component/LoginingAnim")
// require("clover/panel/component/common/UITextButton")
// require("clover/panel/component/common/UIGroupButton")
require("clover/utils/FrameLoader")
require("clover/data/MetaManager")
require("clover/data/GameResLoad")
require("clover/data/DynamicGuideLogic")

require("clover/config/home/HomeConfigManager")
require("clover/utils/Api")
require("clover/utils/Toast")
require("clover/dc/init")
require("clover/utils/GameProxy")
require("clover/utils/TextsManager")
require("clover/utils/IpRegionLimitManager")
require("activity/Promotion/PromotionManager")
// 掉落优化标签
require("clover/logic/userTagData/UserTagData")
require("clover/orthogonalGroup/OrthGroupHelper")
require("clover/orthogonalGroup/OrthStrategyHelper")
require("clover/utils/DYAdUtil")
require("clover/utils/PrivacyUtil")
require("clover/panel/account/AccountManager")
require("activity/GoldMatchActivity/levelLogic/GoldStartLevelLogic")
require("activity/GoldMatchActivity/GoldMatchGetTimesPanel")
require("clover/utils/SpineUtil")
require("clover/debug/QAGUI")
require("clover/animation/config/ParticleAnimationConfig")
require("clover/animation/ui/ParticleAnimation")


// require("clover/cube/CubeOrthGroupHelper") 

let huawei_BG_PATH = ["https://statich5clover.happyelements.com/resource/bg/logo.jpg"]
let BG_PATH = ['assets/loading_bg.jpg']
let TIPS_PATH = ['https://statich5clover.happyelements.com/resource/upload/tips_age2.png', 'https://statich5clover.happyelements.com/resource/upload/hint2.png']

if (getCurrentPlatform() == XcloverPlatform.huawei) {
    BG_PATH = huawei_BG_PATH
}
var SnsProxy = require("clover/sns/SnsProxy")
var PreloadScene = xClass("PreloadScene", BaseScene)
var initCounterNum = 3
var _loadProgress = 1; // 5号打点进度， 2-25% 3-50%， 4-75%
let _userLogined = false;    // 用户是否登陆

let PrivacyHeight = 250
let hintHeight = 180
let progressHeight = 385
let textHeight = 70
let hintDefaultWidth = 750
let ageDefaultWidth = 110
PreloadScene.create = function () {
    QAGUI.getInstance().print("create:"+Localhost.time(), "Preload")
    if (cc.sys.platform !== cc.sys.WECHAT_GAME) {
        let preloader = document.getElementById('preloader')
        preloader && preloader.remove()
        let splash = document.getElementById('splash')
        splash && splash.remove()
    }
    var s = PreloadScene.new()
    s.name = "PreloadScene"
    s.initScene()
    if (window.mini && (mini.getPlatform() == MiniPlatform.wechatGame)){
        getCurrentEvt(()=>{}, true) // 微信提前获取一次code
    }
    return s
}
PreloadScene.tipsText = ["首次加载会有点慢哦~", "拼命加载中..."]
PreloadScene.prototype.dispose = function () {
    var self = this
    //cc.Director:getInstance():getTextureCache():removeUnusedTextures()
    ResManager.release(BG_PATH)
    ResManager.release(TIPS_PATH)
    BaseScene.prototype.dispose.call(self)
}
PreloadScene.prototype.onInit = function () {
    var self = this
    self.isPreloadComplete = false
    self.isPrivacyOpen = false
    self.isReadyToEnter = false
    self.curPercent = 0

    // 背景在代码包内，不含高低清，需要加载完背景再进行初始化
    let orgUseSmallRes = __use_small_res
    __use_small_res = false;
    
    function onBgInit() {
        let text2 = "批准文号：新广出审[2017]5279号\n出版物号：ISBN 978-7-7979-8540-6\n著作权人：乐元素科技（北京）股份有限公司\n出版单位：三辰影库音像出版社\n文网游备字：[2016] M-CSG 8059 号"
        let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
        if (pf == "kuaishou_game"){
            text2 += "\n登记号:2023SR1312703"
        }
        let label2 = cc.Label.create(text2, "Arial", 18)
        label2.setPosition(display.width / 2, textHeight)
        if (window.mini && mini.getPlatform() == MiniPlatform.ks){
        }else{
            label2.setAlignment(cc.TEXT_ALIGNMENT_CENTER)
        }
        self.addChild(label2)

        if (window.mini && mini.supportPlatformLoading())
            mini.loadingComplete({});

        __use_small_res = orgUseSmallRes;

        dc4UserLoad(21);
        self.dispatchEvent({name: "PreloadSceneBgInitEvt"})

        // 统计登录界面总耗时
        self.dc4LoginSession = Localhost.time()
        dc4PreloadSceneLogin("login_request_start", {session:self.dc4LoginSession})
    }
    
    self.mainNode = cc.Layer.create()
    self.mainNode.setPosition(display.center)
    self.addChild(self.mainNode)

    function nothing() {}
    
    ResManager.load(BG_PATH, {
        onSuccess: ()=> {
            let bg = cc.Sprite.create(BG_PATH[0])
            self.addChild(bg, -1)
            let scale = display.height / bg.getContentSize().height
            bg.setScale(scale)
            bg.setPosition(display.center)
            onBgInit();
        },
        onFailure: onBgInit,
        autoRetry: 0
    }).then(nothing)
    .catch(nothing)

    // ResManager.load(TIPS_PATH, {
    //     onSuccess: ()=> {
    //         let tips_age = cc.Sprite.createWithSpriteFrameName(TIPS_PATH[0])
    //         tips_age.setScale(0.8 * ageDefaultWidth / tips_age.getContentSize().width)
    //         tips_age.setPosition(display.width - tips_age.getContentSize().width * 0.5, display.height - tips_age.getContentSize().height * 0.5)
    //         self.addChild(tips_age)

    //         let hint = cc.Sprite.createWithSpriteFrameName(TIPS_PATH[1])
    //         hint.setScale(0.6 * hintDefaultWidth / hint.getContentSize().width )
    //         hint.setPosition(display.width / 2, hintHeight)
    //         self.addChild(hint)
    //         dc4UserLoad(22);
    //     },
    //     onFailure: onBgInit,
    //     autoRetry: 0
    // }).then(nothing)
    // .catch(nothing)

    self.progressDCAble = false;
}

//重新设置场景的坐标位置
PreloadScene.prototype.onViewChanged = function () {
    let self = this

}

PreloadScene.prototype.initPreloadScene = function () {
    var self = this
    self.initPrivacy();
    self.initProgress()
    self.initTip()
    self.prepareGame();
}

PreloadScene.prototype.initPrivacy = function () {
    //oppo平台开启
    var self = this
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    if (!PrivacyUtil.isOpen() || pf == "wanba_ts"){
        return
    }
    //加载隐私资源
    PrivacyUtil.loadRes(()=>{

        var privacy_config =  PrivacyUtil.getPrivacy_config()
        if (!privacy_config){
            return
        }

        //不同意或未选择过隐私政策的强弹
        if (!PrivacyUtil.getPrivacyStorage()){
            self.isPrivacyOpen = true
            PrivacyUtil.openMiniPrivacyPanel(function(){
                //agreecb
                self.isPrivacyOpen = false
                PrivacyUtil.savePrivacyStorage(1)
                if (self.isReadyToEnter){
                    self.gotoNextScene()
                }
                
            },function (){
                //disagreecb
                self.isPrivacyOpen = false
                PrivacyUtil.savePrivacyStorage(0)
                SnsProxy.getInstance().popBack()
            })
               
        }

        console.log("PrivacyUtil.getPrivacyStorage()", PrivacyUtil.getPrivacyStorage())

        

        //加载界面下方的两个按钮
        let offset = 90
        let height = PrivacyHeight

        // 用户协议
        let lable_user = cc.Label.createWithSystemFont(privacy_config["privacy.user_agreement.id"], null, 25)
        lable_user.setTextColor(cc.c4b(154, 252, 255, 255))
        lable_user.setPosition(display.width / 2 - offset, height)
        lable_user.setAnchorPoint(0.5, 0.5)
        lable_user.setContentSize(cc.size(150, 42))
        UIButton.create(lable_user, true).on(UIButtonEvent.Click, function () {
            if (self.isPrivacyOpen){
                return
            }
            self.isPrivacyOpen = true
            PrivacyUtil.openPrivacyPanel("userAgreement", function (){
                self.isPrivacyOpen = false
                if (self.isReadyToEnter){
                    self.gotoNextScene()
                }
            },true)
        })
        self.addChild(lable_user)
        
        //和
        let lable_and = cc.Label.createWithSystemFont("和", null, 25, cc.c4b(255, 255, 255, 255))
        lable_and.setPosition(display.width / 2 , height)
        self.addChild(lable_and)

        // 隐私政策
        let lable_priv = cc.Label.createWithSystemFont(privacy_config["privacy.privacy_policy.id"], null, 25)
        lable_priv.setTextColor(cc.c4b(154, 252, 255, 255))
        lable_priv.setAnchorPoint(0.5, 0.5)
        lable_priv.setContentSize(cc.size(140, 42))
        lable_priv.setPosition(display.width / 2 + offset, height)
        self.addChild(lable_priv)
        UIButton.create(lable_priv, true).on(UIButtonEvent.Click, function () {
            if (self.isPrivacyOpen){
                return
            }
            self.isPrivacyOpen = true
            PrivacyUtil.openPrivacyPanel("privacyPolicy", function (){
                self.isPrivacyOpen = false
                if (self.isReadyToEnter){
                    self.gotoNextScene()
                }
            },true)
        })
    

    
        
    });
    

}

PreloadScene.prototype.onEnterTransitionDidFinish = function () {
    // override以不在此处触发 guide 的初始化
}

// 进度条增加：
// 1.initSdk:+3
// 2.loadResource:+60
// 3.initUser:+10
// 4.ActSubPackage,ActScript:+10
// 5.Texts,Meta:+10
// 6.loadIslandRes:+7
PreloadScene.prototype.prepareGame = function() {
    var self = this
    if (window.mini && mini.getPlatform() == MiniPlatform.vivo){
        self.vivoLoginFailTimes = 0
        self.vivoStartAutoCheck = false
    }


    var successCounter = 0
    QAGUI.getInstance().print("initSdk 1:"+Localhost.time(), "Preload")
    SnsProxy.getInstance().initSdk(function (err) {
        QAGUI.getInstance().print("initSdk 2:"+Localhost.time(), "Preload")
        if (err) {
            throw err;
        }
        self.addPercent(0.03); 
        function onFinishCallback() {
            successCounter = successCounter + 1
            dc4UserLoad(50+successCounter);
            if (successCounter >= initCounterNum) {
                let promiseList = [
                    TextsManager.getInstance().load(),
                    MetaManager.getInstance().initialize(),
                    UserTagData.getInstance().init()
                ]
                QAGUI.getInstance().print("loadMeta 1:"+Localhost.time(), "Preload")
                Promise.all(promiseList)
                .then(()=>{
                    QAGUI.getInstance().print("loadMeta 2:"+Localhost.time(), "Preload")
                    dc4UserLoad(60);
                    self.addPercent(0.1)
                    self.isPreloadComplete = true
    
                    let uid = UserManager.getInstance().getUserRef().uid;
                    let data = {};
                    data.uid = uid;
                    SnsProxy.getInstance().init(data)

                    //获取ip屏蔽信息(获取的时候后端才过滤,所以只要是0就会获取一次)
                    var dcForIpRegion = function(){
                        var isBlock = 0;
                        if (UserManager.getInstance().isAddStepBlock()){
                            isBlock = 1;
                        }
                        DCAssist.userTrack("plusFiveMoves", "type", {"type":(1-isBlock)});
                    }
                    IpRegionLimitManager.getInstance().getRegionStatus(dcForIpRegion)

                    //clover/config/level/init 这里直接放在这里 是因为 ai礼包中的每日特惠礼包检测的请求参数中用到了 获取IslandBookManager.prototype.getTotalMaxStar方法  这里可能baseHomeScene那里并未开启初始化 会因为初始化的问题报错
                    require("clover/config/level/init")
                    // AI礼包Manager启动 必须在MetaManager初始化之后进行，否则无法正确解析充值配置
                    require("activity/AIPackage/AIPkgManager").getInstance().start();
                    //CloverLogic中UserDeal加载时，加载TrinityGiftBagManager脚本
                    TrinityGiftBagManager.getInstance().loadConfig();
                    // 这里是配置的初始化依赖于UserManager初始化后的数据

                    self.ensureActScript(()=>{
                        dc4UserLoad(100);
                        if (!self.isPrivacyOpen){
                            self.gotoNextScene()
                        }else{
                            self.isReadyToEnter = true
                        }
                    })
                    
                }).catch((error)=>{
                    window.logCenter && logCenter.error(new Error(JSON.stringify(error)), "InitTextError");
                    alert("登陆或加载资源失败，请重试！")
                    console.error(error)
                })
            }
        }
        __DEBUG && $timeStamp('start login / load res - 45')       
        self.initUser(function(){
            console.log("initUserSuccess!");
            _userLogined = true;
            dc4UserLoad(55);
            if (self.loading && self.loading.isVisible()) {
                self.addPercent(0.1);
            }
            self.progressDCAble = true;

            // 登录完成就初始化UserManager
            UserManager.getInstance().initFromLua(self.userInfo)
            if (self.init_fail) {
                UserManager.getInstance().createNewUser()
            }
            // 订单状态检查（补单）
            GameProxy.getInstance().payStatusCheck()
            // 加载一下进主界面会用到的海岛ICON
            self.loadIslandRes(function(){
                self.addPercent(0.07)
                onFinishCallback()
            })
        })

        QAGUI.getInstance().print("loadRes 1:"+Localhost.time(), "Preload")
        self.loadResource(()=>{
            QAGUI.getInstance().print("loadRes 2:"+Localhost.time(), "Preload")
            onFinishCallback()
        })

        QAGUI.getInstance().print("loadSub 1:"+Localhost.time(), "Preload")
        self.loadActSubPackage(()=>{
            QAGUI.getInstance().print("loadSub 2:"+Localhost.time(), "Preload")
            self.addPercent(0.1);
            onFinishCallback()
        })

        GameProxy.getInstance().onLoadingComplete()
    })
}

PreloadScene.prototype.ensureActScript = function(callback){
    require.ensure([], () => {
        require("activity/NoviceGift/NoviceGiftManager") 
        require("activity/LightningRush/LightningRushManager") 
        require("activity/NewUserTask/NewUserTaskManager") 
        require("activity/seasideStar/SeasideStarManager") 
        require("clover/data/PiggyBankManager") 
        require("activity/Champion/ChampionLogic")
        require("activity/AdTask/AdTaskLogic")
        require("activity/GoldTurn/GoldTurnLogic");
        require("clover/cube/CubeOrthGroupHelper") 
        require("activity/TimeModeActivity/TimeModeActivityManager")
        require("activity/ShardCollect/ShardCollectLogic")
        require("activity/Common/ActivityGetRewardsPanel")
        require("activity/Common/ActivityAddressPanel")
        require("clover/utils/Dialog")
        require("activity/SpecialShop/SpecialShopManager")
        require("clover/data/MysteryIslandManager")
        require("activity/BuildShip/BuildShipLogic")
        require("clover/data/QualifyGameManager")
        require("activity/StarDream/StarDreamLogic")
        require("activity/DunkAce/DunkAceLogic")
        require("activity/Tetris/TetrisLogic")
        require("activity/AdSkipGiftBag/AdSkipGiftBagLogic")
        require("clover/clover")
        require("activity/SpeedboatMatch/SpeedboatMatchManager")
        require("activity/IslandTreasure/IslandTreasureLogic")
        require("activity/PickCoco/PickCocoManager")
        require("activity/LiveGift/LiveGiftLogic")
        require("activity/CircusGame/CircusGameLogic")
        require("cocos/spine/index");//加载spine相关  进入主场景之前无法使用spine

        this.NewRankLogic = require("clover/scene/component/homescene/NewRank/NewRankLogic");

        callback()
    }, null, 'act')
}

PreloadScene.prototype.cleanSchedulerLoadAct= function(){
    cc.log(" cleanScheduler")
    let self = this
    if (self._schedulerId_loadAct){
        cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_loadAct)
    }
    self._schedulerId_loadAct = null
}
PreloadScene.prototype.loadActSubPackage = function (callback) {
    let self = this
    let name = "act"
    if (!self.loadActCnt) self.loadActCnt = 1

    cc.log("loadAct loadActSubPackage self.loadActCnt ",self.loadActCnt)
    let loadActCb = ()=>{
        cc.log("loadAct loadActCb loadActCnt",self.loadActCnt)
        if (self.loadActCnt > 1){
            cc.log("loadAct loadActCb 只处理一次")
            return
        }
        self.cleanSchedulerLoadAct()
        self.loadActCnt ++
        callback && callback()
    }

    if (window.mini && mini.supportSubpackage()) {
        let start_session = DCAssist.dc4LoadSubPackageStart()
        let start_time = new Date().getTime()

        // self._schedulerId_loadAct = cc.director.getScheduler().scheduleScriptFunc(function () { 
        //     let offset = new Date().getTime() - start_time
        //     if (offset > 3000){
        //         cc.log("loadAct 加载超时处理")
        //         self.cleanSchedulerLoadAct()
        //         mini.showModal({
        //             title: "资源加载失败，请重试",
        //             showCancel: false,
        //             success: function (res) {
        //                 let scene = cc.Director.getInstance().getRunningScene()
        //                 if (scene && scene.name != "PreloadScene") {
        //                     cc.log("loadAct 已经进入游戏无需再次尝试加载")
        //                     return
        //                 }
        //                 if (!self.loadActRetryCcount) {
        //                     self.loadActRetryCcount = 1
        //                 }else{
        //                     self.loadActRetryCcount++
        //                 }
        //                 if (self.loadActRetryCcount <= 1){
        //                     cc.log("loadAct 尝试重新加载分包")
        //                     self.loadActSubPackage(callback)
        //                 }else{
        //                     cc.log("loadAct 重启游戏")
        //                     if (window.mini && mini.restartMiniProgram && mini.supportRestartMiniProgram && mini.supportRestartMiniProgram()){
        //                         mini.restartMiniProgram()
        //                     }else{
        //                         cc.log("loadAct 低版本无重启游戏方法继续尝试加载分包")
        //                         self.loadActSubPackage(callback)
        //                     }
        //                 }
        //             }
        //         }) 
        //     }
        // }, 0.1, false)

        mini.loadSubpackage({
            name: name,
            success: res => {
                console.log("loadActSubPackage res ",res)
                let load_time = 0
                if (start_time){
                    load_time =  (new Date().getTime() - start_time)/1000
                }
                DCAssist.dc4LoadSubPackageSuccess(start_session,load_time)
                loadActCb()
            },
            fail: res => {
                // LogToLogCenter("loadActScript loadSubpackage act fail")
                console.log("loadActSubPackage res ",res)
                let errMsg = "load_fail"
                if (res && res.errMsg) errMsg = res.errMsg
                if (window.logCenter){
                    window.logCenter.error("loadActScript loadSubpackage act fail", "loadActScript", 0, 0, {"stack":"loadSubpackage act errMsg :"+errMsg});
                }else{
                    cc.error("onFrameLoadError:" + res);
                }
                DCAssist.dc4LoadSubPackageFail(start_session,errMsg)
                mini.showModal({
                    title: "资源加载失败，请重试",
                    showCancel: false,
                    success: function (res) {
                        self.loadActSubPackage(callback)
                    }
                }) 
            }
        })
    }else{
        loadActCb()
    }
}

PreloadScene.prototype.loadIslandRes = function (callback) {
    let topIslandId = 0;
    if (UserManager.getInstance().reachTopLevel()) {
        topIslandId = UserManager.getInstance().getCurrentIslandsIdByLevel();
    } else {
        topIslandId = UserManager.getInstance().getIslandsInfo().topId;
        if (topIslandId === 0) {
            topIslandId = UserManager.getInstance().getCurrentIslandsIdByLevel();
        }
    }
    let topIslandConfig = UserManager.getInstance().getIslandConfigById(topIslandId);
    let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager")
    let islandRes = IslandsManager.getInstance().getIslandRes(topIslandConfig);
    preloadWithLoading(islandRes.resList, () => {
        if (callback){
            callback()
        }
    }, null, null, false)
}

PreloadScene.prototype.gotoNextScene = function () {
    console.log("[####]goto next scene")
    var self = this
    

    function callback2(){
        // // 初始化cube分组
        CubeOrthGroupHelper.getInstance().initConfig(MetaManager.getInstance().cubeABtestConfig)
        CubeOrthGroupHelper.getInstance().beforehandStragey()
        //关末广告ab测
        // UserManager.getInstance().initAdABTest()

        // 神秘岛初始化
        MysteryIslandManager.getInstance().updateInfo(UserManager.getInstance().getMysteriousIsland())

        UserTagData.getInstance().parseDropAdjustConfigV2().then(()=>{
            //新掉落优化
            require("clover/gamePlay/DropAdjust/init")
            let DAUserDataV2 = unpack(require("clover/gamePlay/DropAdjust/DAUserDataV2"))[0]
            _G.DAUserDataV2 = DAUserDataV2
            DAUserDataV2.getInstance().setCubeGroup()

        })
        //     // 从新排行炫耀分享进入进行特殊处理
        // let newRankRedirector = EnterGameURL.getInstance().popCachedRedirectorsByName("newrank_showoff");
        // if (newRankRedirector) {
        //     dc4UserLoad(105);
        //     newRankRedirector.runBeforeGotoNextScene(()=> self.gotoNextScene());
        //     return;
        // }

        // 如果新用户从新排行互动邀请启动场景值进入，需要弹出奖励窗
        if (window.mini && mini.getPlatform() === MiniPlatform.wechatGame && mini.getLaunchOptionsSync().query && mini.getLaunchOptionsSync().query.shareMessageToFriendScene == ShareToFriendScene.NewRank && _G.kIsNewUser) {
            // let logic = require("clover/scene/component/homescene/NewRank/NewRankLogic");
            if (!self.NewRankLogic.hasPopNewUserReward()) {
                dc4UserLoad(105);
                self.NewRankLogic.popNewUserReward(()=> self.gotoNextScene());
                return;
            }
        }

        let ChallengeRedirector = require('clover/redirect/ChallengeRedirector')
        let challengeData = ChallengeRedirector.prototype.isChallengeLegal()
        if (self.needResumeLevelDirectly()){
            self.resumeLevelDirectly()
        }else if (challengeData) {
            console.log("[####]goto challengedata")
            self.gotoLevelDirectly(challengeData.challengeLevelId, challengeData)
        }else if (EnterGameURL.getInstance().isRedirectorInCacheHasHighPriorityAction()) {
            console.log("[####]goto home scene")
            self.gotoHome()
        } else if (_G.kIsNewUser) {
            console.log("[####]goto 1 scene")
            self.gotoLevelDirectly(1)
            // //  新玩家由于第一次要直接进入第一次关内，而没有进行关前道具配置加载，导致其会在第五关结束后返回Home场景时候点击下一关报错。因此在这进行加载
            // ItemDataManager.loadPrePropData()
            // //  新玩家由于第一次直接进入第一关内，没有经过BaseHomeScene，导致其UserProduct没有加载Product信息，在购买关末礼包时会报错
            // UserProduct.getInstance().getProductInfo()

            // // 玩家直接进入游戏关可能会因为加载过快引导资源未完成，因此需要等待引导加载完毕再进游戏
            // function startFunc(){
            //     if (GameGuide.getInstance().inited) {
            //         self.gotoLevel(1);
            //     } else {
            //         setTimeout(startFunc, 0);
            //     }
            // }
            // startFunc();
        } else if (__DEBUG) {
            console.log("[####]goto debug")
            let speed = parseFloat(getParameterByName('speed'))
            if (speed) {
                $gameSpeed(speed)
            }

            let replayUid = parseInt(getParameterByName('replay_uid'), 10)
            let replay = getParameterByName('replay')
            let level = parseInt(getParameterByName('level'), 10)

            if (replayUid) {
                
                console.log("[####]goto debug replayuid "+replayUid)
                let content = getParameterByName('content');
                let replayOrder = parseInt(getParameterByName('replay_order'), 10);
                replayOrder = replayOrder ? replayOrder : 1;
                self.loadingComplete(replayUid, replayOrder, content);
            } else if (replay) {
                console.log("[####]goto debug replay "+replay)
                $replay(JSON.parse(replay).replay)
            } else if (getParameterByName('nightmare')) {
                if (Nightmare.replay) {
                    console.log("[####]goto debug nightmare.replay "+Nightmare.replay)
                    $replay(Nightmare.replay)
                } else {
                    console.log("[####]goto debug not exist")
                    
                    throw new Error('replay is not exist')
                }
            } else if (level) {
                console.log("[####]goto debug level "+level)
                self.gotoLevel(level)
            } else {
                console.log("[####]goto debug else home ")
                self.gotoHome()
            }
        } else {
            console.log("[####]goto last home scene")
            self.gotoHome()
        }
        cc.director.registerSceneEventListener(event => {
            
            console.log("[####]scene event "+event)
            if (event === 'beforePopScene' && cc.director._scenesStack.length === 1) {
                console.log("[####]unshift scene")
                cc.director._scenesStack.unshift(require("clover/scene/HomeScene").getInstance())
            }
        })
    }
    
    //wanba隐私政策
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    if (PrivacyUtil.isOpen() && pf == "wanba_ts"){
        let preloadScene = null;
        // if (cc.sys.platform === cc.sys.WECHAT_GAME) {
        //     preloadScene = require("clover/scene/PreloadScene").create();
        // } else {
        preloadScene = require("clover/scene/PreloadSceneWanba").create(callback2);
        // }
        preloadScene.run();

    }else {
        callback2()
    }


   
}

PreloadScene.prototype.initTip = function () {
    let self = this
    require("clover/def/FontDef")
    self.tips = cc.LabelTTF.create(PreloadScene.tipsText[1], FONT_DEF.microsoftYahei_24_blueStroke)
    // let text = self.isOldUserLocal() ? PreloadScene.tipsText[1] : PreloadScene.tipsText[0]
    // self.tips = LoginingAnim.create(text, FONT_DEF.microsoftYahei_24_blueStroke, false)
    self.loading.addChild(self.tips)
    // self.mainNode.addChild(self.tips)
    // self.tips.setPosition(0, -314)
    self.tips.setPosition(0, 50)
    // self.tips.play()
}
PreloadScene.prototype.initEnterGameURLLogic = function() {
    // 在此处处理是因为基本所有的Redirector都需要先登录完成
    require("clover/redirect/BaseRedirector")
    require("clover/data/EnterGameURL")

    // 处理分享登录打点
    let options = window.getLaunchOptions();
    if (options.srcapp && options.srcapp.startsWith("feed_")) {
        if (options.isSmf) {
            DCAssist.dc4SMFShareLaunch(options.srcapp.replace("feed_", ""));
        } else {
            DCAssist.dc4ShareLaunch(options.srcapp.replace("feed_", ""), options.textId, options.inviteCode)
        }
    }

    if (window.mini) {
        let launchOptions = mini.getLaunchOptionsSync();
        let param = launchOptions? EnterGameURL.getInstance().getParams(launchOptions): null;
        EnterGameURL.getInstance().onEnterWithURL(param, launchOptions? launchOptions.shareTicket: null);
        require("clover/utils/IosPayStatusCheckUtil").check(true)
        mini.onShow(res => {
            require("clover/utils/IosPayStatusCheckUtil").check()
            if (res) {
                console.info("wx on show:", res);
                EnterGameURL.getInstance().onEnterWithURL(EnterGameURL.getInstance().getParams(res), res.shareTicket)
            } else {
                EnterGameURL.getInstance().onEnterWithURL()
            }
        })
        if (mini.onAddToFavorites){
            console.log("支持收藏小游戏")
            mini.onAddToFavorites(()=>{
                console.log("用户收藏小游戏")
                DnSdkTool.getInstance().onAddToWishlist()
            })    
        }
        if (mini.onShareTimeline){
            mini.onShareTimeline(()=>{
                console.log("用户分享到朋友圈")
                DnSdkTool.getInstance().track("SHARE",{
                    item:"APP_MESSAGE"
                })
            })
        }
        if (mini.onShareMessageToFriend){
            mini.onShareMessageToFriend(()=>{
                console.log("用户分享到朋友")
                DnSdkTool.getInstance().track("SHARE",{
                    item:"APP_MESSAGE"
                })
            })
        }
    }else{
        EnterGameURL.getInstance().onEnterWithURL(EnterGameURL.getInstance().getParams())
    }
}
PreloadScene.prototype.checkCanUpdate = function (version) {
    let manager = UpdateManager.getInstance()
    if (manager.isSupportUpdate()) {
        // 如果版本需要更新，然后包已经下载完成，可以直接更新
        // 否者需要需要添加事件，等待触发
        manager.setTargetVersion(version)
        if (manager.canUpdate()) {
            manager.forceUpdate()
        }else {
            manager.addReadyListener(() => {
                manager.forceUpdate()
            })
        }
    }
}
PreloadScene.prototype.initUser = function(callback) {
    let retry_time = 2
    let self = this
    let openid, sessionid
    var vivoLoginData

    function authorize(){
        console.log("[!!!!]run authorize")
        SnsProxy.getInstance().checkAuthorizeWithUserBtn(callback, authorize)
    }

    function onSuccess(evt) {
        QAGUI.getInstance().print("h5Login 2:"+Localhost.time(), "Preload")
        // 优先判断处理账号恢复
        
        // 判断账号恢复失败 再次重新登录
        
        // 判断处于账号冻结状态 询问是否恢复账号
        if(evt.data && evt.data.delete_flag == 1){
            // startLoad(failRetry)
            let delete_time = evt.data.delete_time || 0
            let uid = evt.data.uid

            // AccountManager.getInstance().showRecoveryTipPanel({
            //     reloginCb:()=>{
            //         startLoad(failRetry,1)
            //     },
            //     id:uid,
            //     delTime: tonumber(delete_time),
            // })
            // 玩吧特殊处理
            let localDate = new Date(delete_time)
            AccountManager.getInstance().dcRecoveryTipPanelOpen(uid)
            let dateStr= formatDate(localDate, 'yyyy年MM月dd日HH时mm分ss秒')
            let txtString = `您的消消乐账号：${uid}\n    该账号处于停用状态，将于${dateStr}式删除，如您为误操作删除账号，请点击【确定】重新进入游戏。`

            let data = {
                text: txtString,
                needOkBtn: true,
                needCancelBtn: true,
                okBtnText: "确定",
            }
            SnsProxy.getInstance().showDialog(data, ()=>{
                AccountManager.getInstance().dcRecoveryTipPanelClick()
                startLoad(failRetry,1)
            },()=>{
                SnsProxy.getInstance().popBack()
            })
            if (__WIN32){
                // startLoad(failRetry,1)
            }
            return
        }


        // 百度防沉迷
        if (window.mini && mini.getPlatform() === MiniPlatform.baidu && mini.initAntiAddiction){
            console.log("!!!!baidu initAntiAddiction!!!!")
            var sns = SnsProxy.getInstance();
            mini.initAntiAddiction(handler(sns, sns.antiAddictionCb));
        }
        //vivo平台若没有vivo信息，则为获取accesstoken请求
        if (window.mini && 
            mini.getPlatform() == MiniPlatform.vivo &&
            evt.data && !evt.data.user &&
            evt.data.token
            ){
                vivoLoginData.op = "login"
                vivoLoginData.access_token = evt.data.token
                vivoLoginData.refresh_token = evt.data.desc
                vivoLoginData.code = null
                //login
                var http = H5LoginHttp.new()
                http.addEventListener(Events.kComplete, onSuccess)
                http.addEventListener(Events.kError, onError)
                http.addEventListener(Events.kCancel, onCancel)
                http.load(vivoLoginData)

                return
        }
        _G.kIsNewUser = (evt.data || table()).is_new || false
        _G.token = (evt.data || table()).token || 0
        let delayAuthorize = false
        
        if (isWechatGameEnv() || getCurrentPlatform() == XcloverPlatform.huawei) {
            META.user.openid = (evt.data || table()).snsuid || undefined
            openid = META.user.openid
            sessionid = (evt.data || table()).token || 0
            delayAuthorize = (evt.data || table()).delayAuthorize       
        }
        let userInfo = evt.data.user || {}

        if ( window.mini && mini.getPlatform() == MiniPlatform.qqlightGame){
            // 玩吧数据合进qq轻游戏后，让玩家可以选择使用轻游戏或者玩吧的数据
            // 有evt.data.wanba_users说明有玩吧数据可供选择（如果没有qq小游戏数据就直接用玩吧数据重新登录）
            if (evt.data.platform == "wanba_ts"){
                META.specialPFInQQlightgame = "wanba_ts"
            }
            var relogin = function(){
                var http = H5LoginHttp.new()
                http.addEventListener(Events.kComplete, onSuccess)
                http.addEventListener(Events.kError, onError)
                http.addEventListener(Events.kCancel, onCancel)
                // 异步获取数据
                getCurrentEvt(function (data) {
                    http.load(data)
                })
            }
            if (SnsProxy.getInstance().handleLoginDataForMultiData(evt, self.mainNode, relogin)){
                return;
            }
        }

        if (!UserManager.verifyUserData(userInfo)) {
            // console.log("inituser verifyUserData error")
            // Toast.make("用户信息校验错误，请重试！", 5)
            window.logCenter && logCenter.error(new Error("inituser verifyUserData error in qqlightgame"), "LoginError");
            alert("用户信息校验错误，请重试！")
            return
        }

        AuthorizeMgr.initCfg()
        SnsProxy.getInstance().onLoginFinish(openid, sessionid)
        // UserManager.getInstance().initFromLua(userInfo)
        self.userInfo = userInfo
        // 为了打点能够取到uid，这里先提前赋值uid
        UserManager.getInstance().uid = self.userInfo.user && self.userInfo.user.uid || 0
        // 缓存不同用户直接不隔离的用户需要在这里进行一次处理
        SnsProxy.getInstance().checkIsUserChange(UserManager.getInstance().uid);
        // 上次的登录时间，插屏广告用
        UserManager.getInstance().lastLoginSec = self.userInfo.lastLoginSec || 0;
        UserManager.getInstance().canFetchBackReward = self.userInfo.canFetchBackReward || false;
        // 掉落优化用户标签
        // UserManager.getInstance().userLabel = self.userInfo.userLabel;
        UserManager.getInstance().initUserLabel(self.userInfo.userLabel)
        // DnSdk
        DnSdkTool.getInstance().init(evt.data);
        DnSdkTool.getInstance().setOpenId(evt.data.snsuid)
        DnSdkTool.getInstance().onRegister(evt.data)
        DnSdkTool.getInstance().onCreateRole()
        // 微信游戏圈礼包，更新提醒消息
        if (__DEBUG || isWechatGameEnv()){
            // if (__DEBUG){
            //     self.userInfo.wxGifts = table([0, "10001"],[0, "10002"])
            // }
            UserManager.getInstance().wxGifts = $tableToArray(self.userInfo.wxGifts || table())
            console.log("[gift] PreloadScene wxGifts", UserManager.getInstance().wxGifts)
            console.log("[subscribe] PreloadScene lastShowSubscribeWhatsNewTs", UserManager.getInstance().userExtend.lastShowSubscribeWhatsNewTs)
        }
        console.log("【掉落优化tag】 PreloadScene userLabel ",UserManager.getInstance().userLabel)
        SnsProxy.getInstance().onLoadingCompleteInitAd()
        window.switchs = userInfo.settings || table()
        // 灰测打点
        DCAssist.userTrack("abtest", "tag", {
            type: self.userInfo.grayscaleTestId? self.userInfo.grayscaleTestId: "0"
        })
        // console.timeEnd("testLogin")
        //console.timeEnd("testLogin")
        __DEBUG && $timeStamp('login done - 60')    
        // 6x 与 非 6x 打点
        DCAssist.dc4IsUseSmallRes()
        // 读取动画性能，后端记录了设置过画质流畅的机型，如果读出来有一样的机型的话就保持低清
        // 如果记录里没有次机型就按照微信性能等级来
        let hasRecDevice = false
        let gameEffectLevelLow = evt.data.user.userExtend.gameClientSetting.GameEffectLevelLow
        console.log("[setting] gameEffectLevelLow=", gameEffectLevelLow)
        if (gameEffectLevelLow){
            let model = "unknow"
            if (cc.sys.platform === cc.sys.WECHAT_GAME) {
                model = mini.getSystemInfoSync().model
            }
            for(e in gameEffectLevelLow){
                if (e == model){
                    hasRecDevice = true
                    if(gameEffectLevelLow[e] == 1){
                        _G.__level_effect = "LOW"
                    }
                }
            }
        }
        console.log("[setting] hasRecDevice="+hasRecDevice)
        if (hasRecDevice == false){
            // 微信新出的设备性能接口可以直接给设备分档位。0（档位未知），1（高档机），2（中档机），3（低档机）。2.3都分类到低档，按照设置流畅来处理
            // 除mini文件外不再直接使用benchmarkLevel，根据各个平台mini的处理对应到微信的modelLevel
            let modelLevel = 1  
            let deviceBrand = ""
            let deviceModel = ""
            if (window.mini && mini.getSystemInfoSync){
                if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame){
                    QAGUI.getInstance().print("qq benchmarkLevel="+mini.getSystemInfoSync().benchmarkLevel, "setting")
                }else if(window.mini && mini.getPlatform() == MiniPlatform.tt){
                    QAGUI.getInstance().print("tt deviceScore.overall="+mini.getSystemInfoSync().deviceScore.overall, "setting")
                }
                deviceBrand = mini.getSystemInfoSync().brand
                deviceModel = mini.getSystemInfoSync().model
                if (mini.modelLevel && mini.modelLevel > 1){
                    modelLevel = mini.modelLevel
                    _G.__level_effect = "LOW"
                }
            }
            console.log("[setting] deviceModel="+deviceModel+" modelLevel="+modelLevel)
        }
        let ttSmallAmountUseDiamond = evt.data.user.userExtend.gameClientSetting.ttSmallAmountUseDiamondV2 || {value:false}
        UserManager.getInstance().ttSmallAmountUseDiamond = ttSmallAmountUseDiamond.value
        //  保存服务端的速度
        GameSpeedManager.getInstance().saveSpeedFromServer(evt.data.user.userExtend.gameClientSetting)
        if (evt.data.is_new){ //新用户设置默认可影响关卡（主线关）速度
            GameSpeedManager.getInstance().setAllDefaultSpeed(evt.data.user.groupTestInfo.speedUp)
        }
        DCAssist.dc4IslandABTestGroup(evt.data.user.groupTestInfo.islandUnlockStar)
        IpRegionLimitManager.getInstance().init().then(()=>{
            console.log("@@@@init ip region success")
            self.initEnterGameURLLogic()
        }).catch(()=>{
            console.log("@@@@init ip region failed")
            self.initEnterGameURLLogic()
        })
        self.checkCanUpdate(userInfo.settings.latestVersion || "1.0.0")
        //register event
        if (window.mqq && window.OPEN_DATA.qua.app == 'WX'){
            if(window.orientation==90||window.orientation==-90){ 
                Toast.make("游戏只支持竖屏，请切换为竖屏", 2, null, null, display.center.y+200)
                require("activity/QQLive/QQLiveHintPanel").popup(true)  
            }
            window.addEventListener("orientationchange", function(event){
                //Toast.make("当前旋转："+window.orientation)
                if ( window.orientation == 180 || window.orientation == 0 ) 
                {
                    require("activity/QQLive/QQLiveHintPanel").closePanel()
                }
                if( window.orientation == 90 || window.orientation == -90 ) 
                {
                    Toast.make("游戏只支持竖屏，请切换为竖屏", 2, null, null, display.center.y+200)
                    require("activity/QQLive/QQLiveHintPanel").popup(true)
                }
            })
        }

        if ( window.mini && mini.getPlatform() == MiniPlatform.tt){
            // 抖音现在需要判断版本号是否可以分享
            SnsProxy.getInstance().refreshcurVerCanShare();
            // 小额支付每天首次登录打点
            if (now != Localhost.timeInDay(UserManager.getInstance().lastLoginSec)){
                let f = 0
                if (UserManager.getInstance().getTTSmallAmountUseDiamond()){
                    f = 1
                }
                DCAssist.dc4TTAdPay("status", {pf:f})
            }
        }
        
        GameProxy.getInstance().updateNameHeadAfterLogin()

        if (!delayAuthorize){
            authorize()
        }else{
            callback && callback()
        }
    }
    function onError(evt) {
        console.log("@@@@ h5login error evt:"+JSON.stringify(evt))
        console.log("@@@@ h5login error evt:",evt)
        // 统计登录界面总耗时
        dc4PreloadSceneLogin("login_request_start", {session:Localhost.time()})

        if (evt.data){
            console.log("@@@@ login error code ", JSON.stringify(evt.data))
            //服务器停机维护
            if (evt.data == SERVER_GLOBAL_CODE.SERVER_CLOSED_LOGIN){
                if (window.mini){
                    SnsProxy.getInstance().handleLoginDataForServerClose(self.mainNode, startLoad)
                }else{
                    Toast.make("服务器维护中")
                }
                return
            }
            if (tonumber(evt.data)== 761996){
                Toast.make("账号已经被删除了哦~");
            }
            if (evt.data.code == SERVER_GLOBAL_CODE.SERVER_BLACK_LIST){
                let uid = ""
                if (evt.data.desc) uid = evt.data.desc.split(":")[1]
                let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
                if (pf != "wanba_ts" && window.mini){
                    AccountManager.getInstance().showAbnormalTipPanel({uid:uid})
                }else{
                    let txtString = `当前账号（${uid}）处于封禁状态，如有疑问请联系客服。`
                    let data = {
                        text: txtString,
                        needOkBtn: true,
                        needCancelBtn: true,
                        okBtnText: "联系客服",
                        cancelBtnText : "退出游戏"
                    }
                    SnsProxy.getInstance().showDialog(data, ()=>{
                        function onFail() {
                            Toast.make("打开社区错误，请重试！")
                        }
                        OpenFunscareLogic.openFunscare(1, ()=>{
                        }, null, onFail)
                        // if (META.platform == XcloverPlatform.wechatgame) {
                        //     if(mini.openCustomerServiceConversation) {
                        //         mini.openCustomerServiceConversation();
                        //     } else {
                        //         Toast.make("您的App版本过低，请升级后重试");
                        //     }
                        // } else {
                     
                        // }
                    },()=>{
                        SnsProxy.getInstance().popBack()
                    })
                }
                // Toast.make("账号已经黑名单了哦~");
                return
            }
            
        }
        if (retry_time <= 0) {
            // Toast.make("重试数次之后还是错误，请退出重试！", 5)
            if (isWxPlatform()) {
                // 跳转到登录页
                gotoWxPlatformLogin()
            } else {
                var errorMsg = "登录错误，请退出重试！"
                if (Number.isInteger(evt.data) && evt.data > 0) {
                    switch (evt.data) {
                        case 760482:
                            errorMsg = "登录校验计算错误"
                            break

                        case 760483:
                            errorMsg = "登录时间戳错误"
                            break

                        case 760484:
                            errorMsg = "登录时间戳过期"
                            break

                        case 760255:
                            errorMsg = "登录参数不全"
                            break
                    }
                }
                window.logCenter && logCenter.error(new Error(`LoginError code=${evt.data}`), "LoginError");
                alert(errorMsg)
            }
            return
        } else {
            retry_time--
        }
        evt.target.removeAllEventListeners()
        // 防止网络在一段时间之内波动，这里延迟1s执行
        setTimeout(() => {
            startLoad(null, null, true)
        }, 1000);
    }
    function onCancel() {
        // Toast.make("已经取消！")
        alert("已经取消！")
    }
    // var http = isLocalDevelopMode ? MockUserByUUIDHttp.new() : H5LoginHttp.new()
    function startLoad(failRetry, recoveryFlag, autoRetry) {
        var http = H5LoginHttp.new()
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onError)
        http.addEventListener(Events.kCancel, onCancel)
        // 异步获取数据
        QAGUI.getInstance().print("getEvt 1:"+Localhost.time(), "Preload")
        getCurrentEvt(function (data) {
            QAGUI.getInstance().print("getEvt 2:"+Localhost.time(), "Preload")
            dc4UserLoad(33) //获取code
            console.log("[####]vivo data.failRetry", data.failRetry, failRetry, window.mini && mini.getPlatform() == MiniPlatform.vivo)
            if (data.failRetry == 1 && failRetry){
                // vivo多次取消登录后会自动拉起一个登录确认框，那时候就无法回调回来
                if (window.mini && mini.getPlatform() == MiniPlatform.vivo){
                    self.vivoLoginFailTimes = self.vivoLoginFailTimes+1
                    if (self.vivoLoginFailTimes < 3){
                        failRetry();
                    }else if (self.vivoStartAutoCheck == false){
                        self.vivoStartAutoCheck = true
                        function onExit() {}
                        mini.exitMiniProgram(onExit)
                        //self.runAction(cc.RepeatForever.create(
                        //    cc.Sequence.create(cc.DelayTime.create(2), cc.CallFunc.create(startLoad))))
                    }
                }else{
                    failRetry();
                }
                return
            }
            vivoLoginData = data
            let uaapp  = getParameterByName("uaapp");
            cc.log("[Promote Flow]","initUser uaapp",uaapp);
            if (uaapp){
                data.uaapp_type = uaapp;
            }
            if (recoveryFlag == 1){
                data.recoveryFlag = recoveryFlag
            }
            cc.log("[Account]","initUser recoveryFlag",recoveryFlag);
            cc.log("[Account]","initUser data",data);
            console.log("[ad] wechat _G.__CHANNEL_ID=" + tostring(_G.__CHANNEL_ID))
            if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame){
                if (_G.__CHANNEL_ID == null){
                    let adParams = JSON.parse(getAdParams())
                    if (adParams && adParams.channelId){
                        _G.__CHANNEL_ID = adParams.channelId
                    }
                    console.log("[ad] wechat _G.__CHANNEL_ID=" + tostring(_G.__CHANNEL_ID))
                }
                if (_G.__CHANNEL_ID && _G.__CHANNEL_ID != ""){
                    // 媒体投放传来的渠道号，用来标记用户来源
                    data.ad_params = JSON.stringify({[_G.__CHANNEL_ID]:1})
                }
            }
            let install_key = localStorage.getItem("_local_install_key") || ""
            data.install_key = install_key
            http.load(data)
            QAGUI.getInstance().print("h5Login 1:"+Localhost.time(), "Preload")
        },
        false,
        recoveryFlag || autoRetry)
    }
    //sendDc5Log(45)
    // console.time("testLogin")
    var failRetry = function(){
        startLoad(failRetry, null, true);
    }
    startLoad(failRetry)
    // cc.log("[Promote Flow]","mini.getLaunchOptionsSync()",mini.getLaunchOptionsSync());

},
PreloadScene.prototype.isOldUserLocal = function () {
    let localSettingKey = cc.UserDefault.getInstance().getStringForKey("_local_setting_key_", "") !== ""
    return localSettingKey
}

PreloadScene.prototype.loadingComplete = function(replayUid, replayOrder, content) {
    var self = this
    function onFinish(data) {
        var replay = {}
        if (content && content.length != 0) {
            replay = decodeURI(content)
            replay = JSON.parse(replay)
        } else if (replayOrder === 1) {
            replay = data.data.content
        } else if (replayOrder === 2) {
            replay = data.data.earlyContent
        }

        if (replay && replay.length > 0) {
            $replay(replay)
        } else {
            throw new Error('illegal replay')
        }
    }
    function onCancel() {}
    var http = ReadReplayInfoHttp.new(false)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onCancel)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        uid: replayUid
    })
},

PreloadScene.prototype.initProgress = function () {
    var self = this
    // body
    self.loading = require("clover/scene/component/LoadingBar").create()
    // self.loading.setPositionY(-375)
    self.loading.setPosition(display.width/2, progressHeight)
    this.loading.setVisible(false)
    self.addChild(self.loading)
    // self.mainNode.addChild(self.loading)
}
PreloadScene.prototype.updateProgressBar = function(percent) {
    console.log("[Preload] updateProgressBar", percent)
    this.loading.setVisible(!global.hideProgressbar)
    if(this.loading.isVisible()){
        this.loading.setPercent(percent >= 1? 0.99: percent);
    }
},

PreloadScene.prototype.setPercent = function (percent) {
    this.updateProgressBar(percent)
}

PreloadScene.prototype.addPercent = function (percent) {
    console.log("[Preload] addPercent", percent)
    let self = this;
    self.curPercent = self.curPercent + percent
    this.updateProgressBar(self.curPercent)
}
PreloadScene.prototype.loadResource = function(finishCallback) {
    var self = this

    function onLoadResourceComplete(evt) {
        console.log("[####]load resource finish")
        evt.target.rma()
        self.isPreloadComplete = true
        _G.kResourceLoadComplete = true
        if (finishCallback) {
            finishCallback()
        }
    }
    console.log("[####]start load resource")
    // LoadResourceProcessor里的进度也会表现在PreloadScene的进度条上，全都完成进度上涨50%
    var loader = require("clover/loader/LoadResourceProcessor").create()
    loader.addEventListener(Events.kComplete, onLoadResourceComplete)
    loader.start(self)
},

PreloadScene.prototype.gotoHome = function() {
    var self = this
    console.log("[####]go to home")
    if (self.isPreloadComplete) {

        if (window.mini && mini.supportPrivacyAuthorize()) {
            mini.requirePrivacyAuthorize({
                success:function(){

                },
                fail:function(){
                    window.logCenter && logCenter.error(new Error("requirePrivacyAuthorize fail"), "Authorize");
                },
                complete:function(){

                },
            })
        }
        
        console.log("[####]is preloadcomplete")
        
        __DEBUG && $timeStamp('goto home - 70')    
        
        // 统计登录界面总耗时
        let now = Localhost.time()
        let params = {
            session:now, 
            num:now - self.dc4LoginSession,
            type: _G.EnableHttp2 ? "h2" : "original"
        }
        dc4PreloadSceneLogin("login_request_finish", params)
        QAGUI.getInstance().print("gotoHome:"+Localhost.time(), "Preload")

        require.ensure([], () => {
            let homeScene = require("clover/scene/HomeScene").getInstance();
            homeScene.run()
            __DEBUG && $timeStamp('after run home - 90')            
        }, null, 'ggg')
        // require("clover/scene/HomeScene").getInstance().run()
        UserManager.getInstance().dataTemp.loginTime = os.clock()

        //设备统计
        try {
            if (Localhost.getDailyDataByKey("gl_check", false) == false){
                console.log("[gl] check astc")
                if (isPlatformIOS() && !gl.getExtension("WEBGL_compressed_texture_pvrtc")){
                    window.logCenter && logCenter.error(new Error(JSON.stringify(gl.getSupportedExtensions())), 'NotSupportPvrtc');
                }
            
                if ( !gl.getExtension("WEBGL_compressed_texture_astc")){
                    window.logCenter && logCenter.error(new Error(JSON.stringify(gl.getSupportedExtensions())), 'NotSupportAstc');
                }
                Localhost.setDailyDataByKey("gl_check", true)
            }
        } catch (error) {
            
        }
    } else {
        
        console.log("[####]preload not complete, please wait...")
        cc.log("preload not complete, please wait...")
    }
    ParticleAnimation.getInstance()
},

PreloadScene.prototype.gotoLevel = function(id, extraData) {
    let self = this
    if (this.isPreloadComplete) {
        // 很多地方依赖没写，跳过HomeScene导致引用缺失，此处就直接引
        // require("clover/clover")
        // require("clover/scene/HomeScene")
        require('clover/gamePlay/CreateGameSceneLogic')

        // 直接进关，在此处触发redirector
        EnterGameURL.getInstance().handerRedirect()

        // 无限制进关，但不能使用道具
        if (__DEBUG && !extraData && id !== 1) {
            let instance = CreateGameSceneLogic.create(id, table())
            instance.startGamePlayScene(function (fileList) {
                instance.createGamePlayScene(fileList)
            })
            return   
        }

        let [logic, errCode] = require("clover/gamePlay/startEndLevelLogic/StartMainLevelLogic").create(id, extraData)
        if (!logic) {
            if (errCode !== ZooErrorCode.LEVEL_ID_INVALID_START_LEVEL) {
                Toast.make(getText("error.tip." + tostring(errCode)))
            }
            self.gotoHome()
        } else {
            // StartMainLevelLogic的判断中，没有精力会弹出精力面板，故在此提前判断能否开始
            let [success, errCode] = UserLevel.getInstance().canStartLevel(id, table(), extraData)
            if (success) {
                logic.start(() => console.log('fast start level success'), function () {
                    console.error('fast start level failed', arguments)
                }, false)
                logic.startLevel()
            } else {
                console.warn('fast start level failed, can\'t start level', errCode)
                self.gotoHome()
            }
        }
    } else {
        cc.log("preload not complete, please wait...")
    }
},

PreloadScene.prototype.cleanup = function () {
    this.mainNode = null;
    this.tips = null;
    this.loading = null;
    
    var list = [
        BG_PATH,
        "cocos/loading_panel.plist",
        "cocos/loading_panel.png"
    ]

    unloadResList(list);
    
    BaseScene.prototype.cleanup.call(this)
}

/**
 * 玩家直接进入关卡
 * @param {*} id 
 * @param {*} extraData 
 */
PreloadScene.prototype.gotoLevelDirectly = function(id, extraData) {
    let self = this;
    dc4UserLoad(110);
    //  新玩家由于第一次要直接进入第一次关内，而没有进行关前道具配置加载，导致其会在第五关结束后返回Home场景时候点击下一关报错。因此在这进行加载
    ItemDataManager.loadPrePropData()
    //  新玩家由于第一次直接进入第一关内，没有经过BaseHomeScene，导致其UserProduct没有加载Product信息，在购买关末礼包时会报错
    UserProduct.getInstance().getProductInfo()

    // 玩家直接进入游戏关可能会因为加载过快引导资源未完成，因此需要等待引导加载完毕再进游戏
    let schedulerId = 0;
    function checkUpdater() {
        if (GameGuide.getInstance().inited) {
            cc.Director.getInstance().getScheduler().unscheduleScriptEntry(schedulerId);
            schedulerId = 0;
            self.gotoLevel(id, extraData);
        } 
    }
    schedulerId = cc.Director.getInstance().getScheduler().scheduleScriptFunc(checkUpdater, 0, false);
}

/**
 * 玩家直接进入关卡
 * @param {*} id 
 * @param {*} extraData 
 */
PreloadScene.prototype.needResumeLevelDirectly = function() {
    let self = this;
    let lastBatchReplay = UserManager.getInstance().getUserExtendRef().getStartLevelReplay()
    if (!lastBatchReplay) return false
    window.logCenter && logCenter.error(new Error(`get startlevelreplay data from server ` + lastBatchReplay), 'RestartLevelDirectly')

    console.log("startlevelreplay 后端返回", lastBatchReplay)
    lastBatchReplay = JSON.parse(lastBatchReplay)
    var replay = JSON.parse(lastBatchReplay.replay)[1]
    replay = $table(replay)
    let curGroup = UserManager.getInstance().getLevelGroup()
    console.log("[LevelAB] curGroup levelGroup", curGroup, replay.levelGroup)
    if (curGroup != replay.levelGroup) {
        console.log("[LevelAB] 关卡分组发生变化不进行恢复")
        return false
    }        
    // var replayFileUid = lastBatchReplay.uid
    // var currentUid = UserManager.getInstance().uid
    // if ( currentUid == replayFileUid && replay.level) {
        // 检查关卡数
    var levelId = replay.level
    // 检查MD5
    let md5 = ResManager.getLevelMd5(levelId)
    if (md5 == replay.lvmd5) {
        // if (levelId >= LevelConstans.FRIEND_PVP_LEVEL_ID_S && levelId <= LevelConstans.FRIEND_PVP_LEVEL_ID_E && current < expireTimeFriendPvp) // 友谊赛
        // {
        //     lastBatchReplay.replay = replay
        //     self.replayFile = lastBatchReplay
        //     return true;
        // }
        if ((levelId > 0 && levelId < 20000) || // 普通关卡，蓝鲸
            (levelId > 80000 && levelId < 80021) || // 七夕关
            (levelId >= LevelConstans.ACTIVITY_GOLD_ID_S && levelId <= LevelConstans.ACTIVITY_GOLD_ID_E) || // 金币关
            (LevelType.isBuildShipLevel(levelId)) 
        ) {
            lastBatchReplay.replay = replay
            self.replayFile = lastBatchReplay
            // 没有过期
            return true;
        } else if ((levelId >= LevelConstans.MYSTERY_ISLAND_LEVEL_ID_START && levelId <= LevelConstans.MYSTERY_ISLAND_LEVEL_ID_END)) {
            if (UserManager.getInstance().reachTopLevel()) { //神秘岛 如果开了新的最大关卡不闪退续打
                lastBatchReplay.replay = replay
                self.replayFile = lastBatchReplay
                return true
            }
        }
    }
    return false
}
/**
 * 玩家直接进入关卡
 * @param {*} id 
 * @param {*} extraData 
 */
PreloadScene.prototype.resumeLevelDirectly = function(id, extraData) {
    let self = this;
    // dc4UserLoad(110);
    //  新玩家由于第一次要直接进入第一次关内，而没有进行关前道具配置加载，导致其会在第五关结束后返回Home场景时候点击下一关报错。因此在这进行加载
    ItemDataManager.loadPrePropData()
    //  新玩家由于第一次直接进入第一关内，没有经过BaseHomeScene，导致其UserProduct没有加载Product信息，在购买关末礼包时会报错
    UserProduct.getInstance().getProductInfo()

    // 玩家直接进入游戏关可能会因为加载过快引导资源未完成，因此需要等待引导加载完毕再进游戏
    let schedulerId = 0;
    function checkUpdater() {
        if (GameGuide.getInstance().inited) {
            cc.Director.getInstance().getScheduler().unscheduleScriptEntry(schedulerId);
            schedulerId = 0;
            var replay = self.replayFile.replay
            var levelId = self.replayFile.replay.level
            function onFinish(data) {
                var valid = data.data.valid
                function startLevel() {
                    console.log("startlevelreplay 后端验证通过")
                    var selectedItemsData = replay.selectedItemsData
                    var levelType = LevelType.getLevelTypeByLevelId(levelId)
                    // if (levelType == GameLevelType.kGold) {
                    //     UserLevel.getInstance().addLevelTypeEnum(GameLevelType.kGold, GoldUserLevelType)
                    // }
                    // if (levelType == GameLevelType.kPvp){
                    //     var id = replay.id
                    //     var logic = require("activity/PvpActivity/FriendPvpActivityLogic").getInstance();
                    //     logic.resumeReplayGame(levelId, replay);
                    //     HomeScenePopoutQueue.getInstance().pause()
                    //     //self.isBusy = false
                    //     return;
                    // }
                    
                    var currentLevel = UserLevel.getInstance().levelTypeEnum[levelType].create(levelId, selectedItemsData)
                    UserLevel.getInstance().setCurrentLevel(currentLevel)
                    PopoutManager.getInstance().removeAll()
                    //DCAssist.userTrack("resume_replay", "resume", { "replay_level": levelId })
                    var id = replay.id
                    var score = replay.score
                    var scene = cc.Director.getInstance().getRunningScene()
                     if (levelType === GameLevelType.kBuildShip){ 
                        if (replay.buildshipAlreadyStartlevel){
                            require("activity/BuildShip/levelLogic/StartBuildShipLevelLogic").create(levelId, replay.extraData)[0].startReplay(replay, id, score)
                        }else{
                            require("activity/BuildShip/levelLogic/StartBuildShipLevelLogic").create(levelId, replay.extraData)[0].startLevel()
                        }
                        window.logCenter && logCenter.error(new Error(`RestartLevel(buildship) Success` + levelId), 'RestartLevelDirectly')
                                                // self.onClose(false)
                        // self.isBusy = false
                    }else {
                        var logic = CreateGameSceneLogic.create(levelId, table(), null) //selectedItemsData
                        logic.adRefreshCount = data.data.adRefreshCount;
                        if (replay.mysteryIsland){
                            logic.setMysteryIsland(replay.mysteryIsland)
                        }
                        if (replay.levelCollectType){
                            logic.setLevelCollectType(replay.levelCollectType)
                        }
                        if (replay.actPreProp){
                            logic.setActPreProp(replay.actPreProp)
                            if (replay.actPreProp.purpleAmyMagic && replay.actPreProp.purpleAmyMagic.streakBuff){
                                PurpleAmyMagicManager.getInstance().updateInfo({
                                    streakBuff: replay.actPreProp.purpleAmyMagic.streakBuff
                                })
                            }
                        }
                        
                        logic.startReplayGamePlayScene(replay, id, score)
                        window.logCenter && logCenter.error(new Error(`RestartLevel Success` + levelId), 'RestartLevelDirectly')
                        HomeScenePopoutQueue.getInstance().pause()
                        //self.isBusy = false
                    }
                }
                if (valid) {
                    startLevel()
                } else if (MetaManager.getInstance().getIsGuideByLevelId(levelId)) {
                    // 教学关卡随机种子相同，可以重复恢复
                    startLevel()
                } else {
                    Toast.make("关卡只能恢复一次")
                    self.gotoHome()
                    //DCAssist.userTrack("resume_replay", "fail", { "replay_fail_reason": "repeat", "replay_level": levelId })
                    // self.complete()
                    //self.isBusy = false
                }
            }
    
            function onError() {
                Toast.make("数据错误，恢复失败")
                // self.complete()
                // DCAssist.userTrack("resume_replay", "fail", { "replay_fail_reason": "server error", "replay_level": levelId })
                //self.isBusy = false
                self.gotoHome()
            }
    
            function onCancel() {
                // Toast.make("取消恢复")
                // self.complete()
                // DCAssist.userTrack("resume_replay", "server_cancel", { "replay_level": levelId })
                //self.isBusy = false
                self.gotoHome()
            }
    
            var http = ResumeGameReplayHttp.new(true)
            http.addEventListener(Events.kComplete, onFinish)
            http.addEventListener(Events.kError, onError)
            http.addEventListener(Events.kCancel, onCancel)
            http.load(replay.level, replay.randomSeed)
        } 
    }
    schedulerId = cc.Director.getInstance().getScheduler().scheduleScriptFunc(checkUpdater, 0, false);
}
module.exports = PreloadScene
